import React, { useState, useEffect } from "react";
import { fetcher, postsFetcher } from "../../utils/request";
import getEnvEndpoints from "../../utils/endpoints";
import ShortFeedItem from "../common/ShortFeedItem";
import CardHeader from "./common/CardHeader";
import CardSubheader from "./common/CardSubheader";
import CardFooter from "./common/CardFooter";
import CardPreviewImage from "./common/CardPreviewImage";
import CardFilterPills from "./common/CardFilterPills";
import { previewImageOfPost, appendEllipsis } from "../../utils/helper";
import PdfViewer from "./common/PdfViewer";
import { getContentDetailsOnClick } from "../../utils/utility";

const Pmbok = ({
  post,
  showPmbokModal,
  showShareModal,
  showFeedbackModal,
  cardFilterSelected,
  canProceed,
  isAuthenticated,
  playlists,
  lookup,
  feedbackSentContentKeys,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id
}) => {
  const [expanded, setExpanded] = useState(false);
  const [pmbokContent, setPmbokContent] = useState({
    loaded: false,
    data: null,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (expanded) {
      setExpanded(false);
      setPmbokContent({
        loaded: false,
        data: null,
      });
    }
  }, [post]);

  async function toggleExpand() {
    if (expanded) {
      const el = document.getElementById(`#${post.contentKey}`);
         if (post.isPublic && post.publishUntilDate && ((post.isPublic) && (new Date (post.publishUntilDate) > new Date()) )) {
        getContentDetailsOnClick(post, 'less', 'card-content');}
      el.scrollIntoView();
      setPmbokContent({
        loaded: false,
        data: null,
      });
    } else {
      if (!pmbokContent.loaded && post?.attributionSources.length !== 0) {
        const id = post?.attributionSources[0].link;
        const bookname = post?.attributionSources[0].book;
        if (!id.trim().length) return;
        if (!bookname.trim().length) return;
        const fragments = id.split(":");
        setLoading(true);
        if (post.isPublic && post.publishUntilDate && ((post.isPublic) && (new Date (post.publishUntilDate) > new Date()) )) {
     const data = await fetcher(  `SharedPosts/${bookname}/fragments/${fragments}/${post.id}`);
  setLoading(false);
        setPmbokContent({ loaded: true, data });
         getContentDetailsOnClick(post, 'more', 'card-content');
      }else{
        try {
          const data = await fetcher(
            `/api/pmbok/${bookname}/fragments/${fragments}`
          );
          await Promise.all(data.map(async fragment => {
            if (!fragment.fields.SubType) return;
            const bytes = await postsFetcher("/api/pmbok/pdf", null, {
              params: { uri: fragment.fields.Content || getEnvEndpoints().pmbok7TocUrl },
              responseType: "arraybuffer"
            });
            if (!bytes) throw new Error("Unable to retrieve PDF bytes.");
            fragment.fields.Content = { data: new Uint8Array(bytes) };
          }));
          setPmbokContent({ loaded: true, data });
        } catch (error) {
          console.error("Unable to load PDF.", error);
        } finally {
          setLoading(false);
        }
      }
    }}
    setExpanded(!expanded);
  }
  const previewImage = previewImageOfPost(post);

  return fullcard ? (
    <div
      className={
        "flex border border-gray-500 rounded-sm mb-5 " +
        (post.status !== "Published" ? "bg-gray-400" : "bg-white")
      }
    >
      <div className="w-full">
        <CardHeader
          post={post}
          showPmbokModal={showPmbokModal}
          canProceed={canProceed}
        />
        <div className="px-5 mt-4">
          <div className={"cursor-pointer"} onClick={toggleExpand}>
            <CardSubheader subheader={post.title} />
          </div>
          {previewImage && (
            <div className="cursor-pointer" onClick={toggleExpand}>
              <CardPreviewImage
                previewImage={previewImage?.filePath || previewImage}
              />
            </div>
          )}
          {expanded ? (
            <div
              className="relative overflow-hidden select-none"
              onContextMenu={(e) => e.preventDefault()}
            >
              {(pmbokContent.data &&
                pmbokContent.data.map((fragment) => {
                  return (
                    (!fragment?.fields.SubType && (
                      <div className="content-fragment" key={fragment?.id}>
                        <div
                          className="content-styling"
                          dangerouslySetInnerHTML={{
                            __html: fragment?.fields.Content,
                          }}
                        />
                      </div>
                    )) || (
                      <PdfViewer
                        key={`pdf` + fragment?.id}
                        fragment={fragment}
                        fragmentZoom={1.0}
                      />
                    )
                  );
                })) || (
                <>
                  <div className="content-fragment" key={post?.id}>
                    <div
                      className="content-styling"
                      dangerouslySetInnerHTML={{
                        __html: post?.fullContent,
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          ) : (
            <div
              className="text-base font-normal mb-2"
              dangerouslySetInnerHTML={{
                __html: post.description && appendEllipsis(post.description),
              }}
            />
          )}
          <div className="my-3 mx-auto" style={{ width: "120px" }}>
            <div
              className="bg-blue-700 rounded-lg py-2 text-center cursor-pointer"
              onClick={toggleExpand}
            >
              <h5 className="text-white text-xs lg:text-sm uppercase">
                {loading && <i className="fas fa-spin fa-spinner mr-3" />}
                {expanded ? "Less" : "More"}
              </h5>
            </div>
          </div>
          <CardFilterPills
            post={post}
            lookup={lookup}
            canProceed={canProceed}
            cardFilterSelected={cardFilterSelected}
          />
        </div>
        <CardFooter
          post={post}
          showShareModal={showShareModal}
          showFeedbackModal={showFeedbackModal}
          canProceed={canProceed}
          isAuthenticated={isAuthenticated}
          feedbackSentContentKeys={feedbackSentContentKeys}
          playlists={playlists}
          propGroup={propGroup}
          userLikes={userLikes}
          feedbacks={feedbacks}
          contentKey={contentKey}
          id={id}
        />
      </div>
    </div>
  ) : (
    <ShortFeedItem post={post} playlists={playlists} />
  );
};

export default Pmbok;
